import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Hours } from 'wsm-hours';
import { setClassNames } from '@ddc/classnames-js';
import { useDetailedHours } from '../features/detailedHours/detailedHoursSlice';
import './HoursModal.scss';

const HoursModal = ({ show, onHide }) => {
	const { detailedHours } = useDetailedHours();
	const titleClasses = setClassNames(['h2', 'my-0']);
	const closeButtonClassNames = setClassNames([
		'absolute-right',
		'btn-link',
		'mr-2',
		'text-decoration-none'
	]);
	const closeIconClassNames = setClassNames([
		'ddc-icon',
		'ddc-icon-remove2',
		'ddc-icon-size-xlarge'
	]);
	const modalBodyClassNames = setClassNames([
		'pt-0',
		'ddc-font-size-small',
		'overflow-auto'
	]);

	if (!show) {
		return null;
	}

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header>
				<button
					type="button"
					aria-label="close"
					className={closeButtonClassNames}
					onClick={onHide}
				>
					<i className={closeIconClassNames} aria-hidden="true" />
				</button>
				<Modal.Title className={titleClasses}>Hours</Modal.Title>
			</Modal.Header>
			<Modal.Body className={modalBodyClassNames}>
				{detailedHours.map((hours) => {
					const label = Object.keys(hours)[0];
					return (
						<Hours
							key={label}
							hours={hours}
							allHoursDepts={label}
							allHoursLabelIds={label}
							hoursTextAlignment=""
						/>
					);
				})}
			</Modal.Body>
		</Modal>
	);
};

HoursModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired
};

export default HoursModal;
